import * as React from 'react';
import FormItem from 'antd/lib/form/FormItem';
import Tooltip from 'antd/lib/tooltip';
import Input from 'antd/lib/input';
import Loader from 'src/components/common/Loader';
import GenericHoc from 'src/components/hoc/GenericHoc';
import ServicesIcon from './create-shipment.svg/services';
import AddressIcon from './create-shipment.svg/address';
import SelectPickupDrop from 'src/components/common/CommonSelect/SelectPickupDrop';
import SelectStuffing from 'src/components/common/CommonSelect/SelectStuffing';
import SelectServices from 'src/components/common/CommonSelect/SelectServices';
import { HocOptions } from 'src/components/hoc/GenericHoc.types';
import { newShipmentSecondStyles } from './new-shipment.styles';
import { NewShipmentSecondProps, FormField } from './new-shipment.types';
import { ShipmentFormFields, formItemLayout } from './new-shipment.constants';
import SelectPlant from 'src/components/common/CommonSelect/SelectPlant';
import { formRules } from 'src/Library/Helper';
import { ModesOfService, StakeholderTypes } from 'src/Library/Constants';
import { isBreakBulkMode } from '../SE.constants';

const NewShipmentSecond = (props: NewShipmentSecondProps) => {

  const { classes, form, editData, executionMaster, formFieldConfig, hide, isBlNumberPresent, isFieldDiabled, stakeholderAccountType } = props;

  const { getFieldDecorator } = form;

  const [loading, setLoading] = React.useState(false);
  const [loadingLocationVisible, setLoadingLocationVisible] = React.useState<boolean>(true);
  const [unLoadingLocationVisible, setUnLoadingLocationVisible] = React.useState<boolean>(true);

  const {
    MODE,
    TNC,
    PICKUP,
    LOADING,
    UNLOADING,
    LOADINGLOCATION,
    UNLOADINGLOCATION,
    ORIGIN_SERVICE,
    ORIGIN_ADDRESS,
    DESTINATION_ADDRESS,
    DESTINATION_SERVICE,
  } = ShipmentFormFields;

  const {
    allowedPickupAndDrop,
    shippingModeToValidServicesMapping,
    locationTypeAtOriginAndDestination,
  } = executionMaster;

  const modeOfService = form.getFieldsValue()[MODE.key];
  const pickupAndDropType = form.getFieldsValue()[PICKUP.key];
  const loadingType = form.getFieldsValue()[LOADING.key];
  const unLoadingType = form.getFieldsValue()[UNLOADING.key];

  function setInitial() {
    form.setFieldsValue({
      [PICKUP.key]: editData?.pickupAndDrop || allowedPickupAndDrop[0],
      [LOADINGLOCATION.key]: editData?.[LOADINGLOCATION.key],
      [UNLOADINGLOCATION.key]: editData?.[UNLOADINGLOCATION.key],
    });
  }

  React.useEffect(() => {
    setInitial();
  }, []);

  React.useEffect(() => {
    // if (loadingType === 'Factory' && editData?.type === MOVEMENT_TYPES.EXPORT) {
    if (loadingType === 'Factory') {
      setLoadingLocationVisible(true);
      return;
    }
    setLoadingLocationVisible(false);
    form.setFieldsValue({ [LOADINGLOCATION.key]: undefined });
  }, [loadingType]);

  React.useEffect(() => {
    // if (unLoadingType === 'Factory' && editData?.type === MOVEMENT_TYPES.IMPORT) {
    if (unLoadingType === 'Factory') {
      setUnLoadingLocationVisible(true);
      return;
    }
    setUnLoadingLocationVisible(false);
    form.setFieldsValue({ [UNLOADINGLOCATION.key]: undefined });
  }, [unLoadingType]);


  const getLabel = (label: string, required = false) => {
    return <span
      className={classes.ellipses}
    >
      <Tooltip title={label}>
        {label}
      </Tooltip>
      {!isBlNumberPresent && required && <span className={classes.required}>
        *
      </span>}
    </span>;
  };

  const renderServicesTitle = () => {
    return <div className={classes.boxTitle}>
      <div className={classes.boxIcon}>
        <ServicesIcon className={classes.boxIcon} />
      </div>
      <span>Services</span>
    </div>;
  };

  function getServiceList() {
    if (!editData?.mode) {
      return shippingModeToValidServicesMapping.FCL;
    }
    // Break Bulk mirrors LCL: fall back to LCL services when master data has no Break Bulk key.
    const serviceMode = isBreakBulkMode(editData.mode) ? ModesOfService.LCL : editData.mode;
    return shippingModeToValidServicesMapping[serviceMode];
  }

  const renderServicesList = (field: FormField) => {
    const allowedServices = getServiceList();
    const isRequired = !isBlNumberPresent && (formFieldConfig[field.configKey] ?? false);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <FormItem
      label={<div style={{ marginTop: 12 }}>
        {getLabel(field.label, isRequired)}
      </div>}
      className={classes.formItem}
      {...formItemLayout}
      style={{ alignItems: 'normal' }}
    >
      {getFieldDecorator(field.key, {
        initialValue: editData?.id ? editData[field.key] : [],
        rules: [rules]
      })(<SelectServices
        disabled={isFieldDiabled(field.disableKey)}
        options={allowedServices}
        className={classes.checkboxGroup}
      />)}
    </FormItem>;
  };


  const renderServiceField = () => {
    return <div
      className={classes.boxFields}
      style={{ display: 'flex' }}>
      {renderServicesList(ORIGIN_SERVICE)}
      {renderServicesList(DESTINATION_SERVICE)}
    </div>;
  };

  const renderServices = () => {
    return <div className={classes.box}>
      {renderServicesTitle()}
      {renderServiceField()}
    </div>;
  };

  const renderAddressTitle = () => {
    return <div className={classes.boxTitle}>
      <div className={classes.boxIcon}>
        <AddressIcon className={classes.boxIcon} />
      </div>
      <span>Address</span>
    </div>;
  };

  const renderPickup = () => {
    const isRequired = !isBlNumberPresent && (formFieldConfig[PICKUP.configKey] ?? false);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <FormItem
      label={getLabel(PICKUP.label, isRequired)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(PICKUP.key, {
        rules: [rules]
      })(<SelectPickupDrop
        allowedPickupAndDrop={allowedPickupAndDrop}
        className={classes.input}
        disabled={isFieldDiabled('pickupDisabled')}
      />)}
    </FormItem>;
  };

  const renderAddressInput = (field: FormField) => {
    let originstuffingDestuffingAddress;
    let destinationstuffingDestuffingAddress;
    if (field.key === 'originAddress'){
      originstuffingDestuffingAddress = editData?.originStuffingAddress;
    }
    if (field.key === 'destinationAddress'){
      destinationstuffingDestuffingAddress = editData?.destinationStuffingAddress;
    }
    const isRequired = !isBlNumberPresent && (formFieldConfig[field.configKey] ?? false);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <FormItem
      label={getLabel(field.label, isRequired)}
      className={classes.formItem}
      {...formItemLayout}
      style={{ alignItems: 'normal' }}
    >
      {getFieldDecorator(field.key, {
        initialValue: originstuffingDestuffingAddress || destinationstuffingDestuffingAddress,
        rules: [rules]
      })(<Input.TextArea
        style={{ width: 300 }}
        autoSize={{ minRows: 3, maxRows: 6 }}
        placeholder={field.placeholder}
        className={classes.input}
        disabled={isFieldDiabled(field.disableKey)}
      />)}
    </FormItem>;
  };

  const renderLocation = (field: FormField) => {
    const isRequired = !isBlNumberPresent && (formFieldConfig[field.configKey] ?? false);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <FormItem
      label={getLabel(field.label, isRequired)}
      className={classes.formItem}
      {...formItemLayout}
    >
      {getFieldDecorator(field.key, {
        initialValue: editData?.id ? editData[field.key] : undefined,
        rules: [rules]
      })(<SelectStuffing
        placeholder={field.placeholder}
        className={classes.input}
        disabled={isFieldDiabled('stuffingDisabled')}
        locations={locationTypeAtOriginAndDestination}
        />)}
    </FormItem>;
  };

  const renderPlant = (field: FormField) => {
    const isCustomer = stakeholderAccountType === StakeholderTypes.CUSTOMER;
    const shipperId = isCustomer ? form.getFieldValue('shipperId') : undefined;
    if (
      (loadingLocationVisible && field.key === LOADINGLOCATION.key) ||
      (unLoadingLocationVisible && field.key === UNLOADINGLOCATION.key)
    ) {
      const isRequired = !isBlNumberPresent && (formFieldConfig[field.configKey] ?? false);
      const rules = {...formRules.required};
      rules.required = isRequired
      return <FormItem
        label={getLabel(field.label, isRequired)}
        className={classes.formItem}
        {...formItemLayout}
      >
        {getFieldDecorator(field.key, {
          initialValue: editData?.[field.key] || undefined,
          rules: [rules]
        })(<SelectPlant
          addressType={field.addressType}
          shipperId={shipperId}
          className={classes.input}
          placeholder={field.placeholder}
        />)}
      </FormItem>;
    }
    return;
  };

  const renderAddressField = () => {
    return <div className={classes.boxFields}>
      <div className={classes.flexRow}>
        {renderPickup()}
      </div>
      <div className={classes.flexRow}>
        {renderAddressInput(ORIGIN_ADDRESS) || <div style={{ width: '50%' }}/>}
        {renderAddressInput(DESTINATION_ADDRESS)}
      </div>
      <div className={classes.flexRow}>
        {renderLocation(LOADING)}
        {renderLocation(UNLOADING)}
      </div>
      <div className={classes.flexRow}>
        {renderPlant(LOADINGLOCATION) || <div style={{ width: '50%' }}/>}
        {renderPlant(UNLOADINGLOCATION)}
      </div>
    </div>;
  };

  const renderAddress = () => {
    return <div className={classes.box}>
      {renderAddressTitle()}
      {renderAddressField()}
    </div>;
  };

  const renderTnc = () => {
    const isRequired = !isBlNumberPresent && (formFieldConfig[TNC.configKey] ?? TNC.required);
    const rules = {...formRules.required};
    rules.required = isRequired
    return <div className={classes.box}>
      <span className={classes.boxTitle} style={{ width: '17%' }}>
        {getLabel('Terms & Conditions', isRequired)}
      </span>
      <FormItem
        {...formItemLayout}
        className={classes.formItem}
        style={{ width: '100%' }}
      >
        {form.getFieldDecorator(TNC.key, {
          initialValue: editData?.termsAndConditions,
          rules: [rules]
        })(
          <Input.TextArea
            disabled={isFieldDiabled('tncDisabled')}
            style={{ minWidth: 870 }}
            autoSize={{ maxRows: 10, minRows: 4 }}
            placeholder={TNC.placeholder}
          />)}
      </FormItem>
    </div>;
  };

  if (loading) {
    return <Loader />;
  }

  const roadBasedModes = [ModesOfService.DOMESTIC, ModesOfService.RPTL];
  const isRoadBased = roadBasedModes.includes(modeOfService);

  return <div className={classes.main} style={{display: hide ? 'none' : 'block'}}>
    {!isRoadBased && renderServices()}
    {!isRoadBased && renderAddress()}
    {renderTnc()}
  </div>;
};

const options: HocOptions = {
  connectJss: {
    useJss: true,
    styleSheet: newShipmentSecondStyles,
  },
  ignoreWithAuth: true,
};

const StepTwo = GenericHoc(options)(NewShipmentSecond);
export default StepTwo;
